import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { theme } from '@garnish/constants';
import { Icon } from '@garnish/core';
import { LoadingDots } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2AddToBagIcon = (props: Props) => {
  const { isDisabled, isLoading, style } = props;

  const iconColor = isDisabled ? theme.colors.OPACITY.DARK_KALE.LIGHT : theme.colors.CHARCOAL;

  return (
    <View style={[styles.container, style]} pointerEvents="none">
      {isLoading ? (
        <LoadingDots color={iconColor} />
      ) : (
        <Icon name="IconPlus" width={ICON_SIZE} height={ICON_SIZE} color={iconColor} />
      )}
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTAINER_SIZE = 40;
const ICON_SIZE = 30;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: CONTAINER_SIZE,
    height: CONTAINER_SIZE,
    borderRadius: CONTAINER_SIZE,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  isLoading: boolean;
  style?: ViewProps['style'];
};
